import { Component } from '@angular/core';
import { BaseDirectoryEditComponent } from '../base-directory-edit/base-directory-edit.component';

@Component({
   selector: 'samweb-non-editable-field',
   templateUrl: './non-editable-field.component.html',
   styleUrls: ['./non-editable-field.component.scss'],
})
export class NonEditableFieldComponent extends BaseDirectoryEditComponent {
   constructor() {
      super();
   }
}
